import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Handler from "../../Helpers/Components/Handler";
import Modal from "../../Helpers/Components/Modal";
import Edit from './Edit'
import Add from "./Add";
import * as bootstrap from "bootstrap";
import moment from "moment";

const Lead = () => {
    const { leadId } = useParams()
    const [loading, setLoading] = useState(false)
    const [leadDetails, setLeadDetails] = useState({})
    const [viewModal, setViewModal] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const [notes, setNotes] = useState({ modal: false })
    const navigate = useNavigate()
    const getDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: 'GET', url: `/lead/view/${leadId}` })
        if (response.success) {
            setLeadDetails(response.data)
        } else {
            setLeadDetails({})
        }
        setLoading(false)
    }
    useEffect(() => {
        getDetails()
    }, [leadId])
    return (
        <React.Fragment>
            <Modal header={"Lead Details"} size={"lg"} onShow={viewModal} toggle={() => setViewModal(false)} overlayToggle={() => setViewModal(false)}><Edit leadId={leadId} /></Modal>
            <Modal header={"Edit Member"} size={"lg"} onShow={editModal} toggle={() => setEditModal(false)} overlayToggle={() => setEditModal(false)}>
                <Add detail={leadDetails} />
            </Modal>
            <Modal header={"Reason"} size={"lg"} onShow={notes?.modal} toggle={() => setNotes({ modal: false })} overlayToggle={() => setNotes({ modal: false })}>
                <div className="modal-body text-capitalize">
                    {notes?.note}
                </div>
            </Modal>
            <div className="view-fixed">
                <div className="row px-5">
                    <div className="text-center col-md-4 text-capitalize"><span className="topTitle">Created By : </span>{leadDetails?.createdId || "-"}</div>
                    <div className="text-center col-md-4"><span className="topTitle">Phone : </span>{(leadDetails?.code || "") + (leadDetails.phone || "-")}</div>
                    <div className="text-center col-md-4"><span className="topTitle">Register Date : </span>{leadDetails?.createdAt || leadDetails?.registerDate ? moment(new Date(leadDetails?.registerDate || leadDetails?.createdAt))?.format('DD/MM/YYYY') : "-"}</div>
                </div>
                <div className="inside-back-arrow"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
            </div>
            {/* {
                leadDetails?.status === "Converted" || leadDetails?.status === "Rejected" ? "" : */}
            <div className="d-flex align-items-center justify-content-end my-3 gap-2">
                <button className="btn lead-btn" disabled={loading} onClick={() => setEditModal(true)}> <i className="fa-solid fa-pen-to-square"></i> </button>
                <button className="btn lead-btn" disabled={loading} onClick={() => setViewModal(true)}><i className="fa-solid fa-plus"></i></button>
            </div>
            {/* } */}
            {
                !loading ?
                    (leadDetails.notes?.length ? "" :
                        <div className="row justify-content-center my-4">
                            <div className="col-xl-4 col-lg-5 col-md-6 col-sm-9">
                                <div className="profile-card">
                                    <p className="mb-4 profile-head">Profile </p>
                                    <div className="row mb-3 justify-content-center">
                                        <div className="col-5">
                                            <label>Type </label>
                                        </div>
                                        <div className="col-5">
                                            <label className="fw-medium text-uppercase">{leadDetails?.type || "-"}</label>
                                        </div>
                                    </div>
                                    <div className="row mb-3 justify-content-center">
                                        <div className="col-5">
                                            <label>Phone </label>
                                        </div>
                                        <div className="col-5">
                                            <label className="fw-medium d-flex align-items-center justify-content-start gap-2"> <span>{leadDetails?.code || ""} {leadDetails?.phone || "-"}</span> <button className="btn link-btn p-0" onClick={() => setEditModal(true)}><i className="fa-solid fa-pen-to-square"></i></button></label>
                                        </div>
                                    </div>
                                    <div className="row mb-3 justify-content-center">
                                        <div className="col-5">
                                            <label>Name </label>
                                        </div>
                                        <div className="col-5">
                                            <label className="fw-medium text-capitalize">{leadDetails?.name || "-"}</label>
                                        </div>
                                    </div>
                                    <div className="row mb-3 justify-content-center">
                                        <div className="col-5">
                                            <label>Source </label>
                                        </div>
                                        <div className="col-5">
                                            <label className="fw-medium text-capitalize">{leadDetails?.src || "-"}</label>
                                        </div>
                                    </div>
                                    {
                                        leadDetails?.src === "WA" || leadDetails?.src === "DC" ?
                                            <div className="row mb-3 justify-content-center">
                                                <div className="col-5">
                                                    <label>Source Number</label>
                                                </div>
                                                <div className="col-5">
                                                    <label className="fw-medium text-capitalize">{leadDetails?.srcNumber || "-"}</label>
                                                </div>
                                            </div>
                                            : ""
                                    }
                                    <div className="row mb-3 justify-content-center">
                                        <div className="col-5">
                                            <label>Address </label>
                                        </div>
                                        <div className="col-5">
                                            <label className="fw-medium text-capitalize">{leadDetails?.address || "-"}</label>
                                        </div>
                                    </div>
                                    <div className="row mb-3 justify-content-center">
                                        <div className="col-5">
                                            <label>Email ID </label>
                                        </div>
                                        <div className="col-5">
                                            <label className="fw-medium text-capitalize">{leadDetails?.email || "-"}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)
                    : ""
            }
            <div className="row align-items-center my-4 align-items-stretch">
                {
                    leadDetails.notes?.length && !loading ?
                        <div className="col-12 mb-4">
                            <div className="profile-card h-100">
                                <div className='overflow list-table'>
                                    <table className="table-bg table" borderless="true">
                                        <thead>
                                            <tr className="border-bottom" >
                                                <th>Remark</th>
                                                <th>Created At</th>
                                                <th>Created By</th>
                                                <th>Follow Up</th>
                                                <th>Car Req</th>
                                                <th>No. of Days</th>
                                                {/* <th>Comment</th> */}
                                                <th>Followed By</th>
                                                <th>Note</th>
                                                <th>Phone</th>
                                                <th>Whatsapp</th>
                                            </tr>
                                        </thead>
                                        {leadDetails?.notes?.map((element, key) => {
                                            return (
                                                <tbody>
                                                    <tr key={key} className={`table-content-row ${element?.status === "Rejected" ? "text-red" : ""}`}>
                                                        <td><div className="d-flex flex-column"><span className="text-capitalize">{(element?.remark || "")}</span></div></td>
                                                        <td>{element?.createdAt ? moment(element?.createdAt).format('DD/MM/YYYY hh:mm A') : ""}</td>
                                                        <td className="text-capitalize">{element?.followedBy || ""}</td>
                                                        <td>{element?.followUp ? moment(element?.followUp).format('DD/MM/YYYY') : ""}</td>
                                                        <td>
                                                            <div className="d-flex flex-column">
                                                                <span>{leadDetails.carReq ? moment(leadDetails.carReq).format('DD/MM/YYYY') : ""}</span>
                                                                <span>{element?.carType || ""}</span>
                                                            </div>
                                                        </td>
                                                        <td>{element?.days || "-"}</td>
                                                        {/* <td>{element?.message ? (element?.message?.slice(0, 10) + (element?.message?.length > 10 ? "..." : "")) : ""}</td> */}
                                                        <td className="text-capitalize">{element?.followedBy || "-"}</td>
                                                        <td>{element?.note ? (element?.note?.slice(0, 10) + (element?.note?.length > 10 ? "..." : "")) : ""}<button className="btn border-0 p-0 ms-1 text-danger" onClick={() => setNotes({ modal: true, note: element?.note })}><i className="fa-solid fa-eye"></i></button></td>
                                                        <td>{element?.phoneFollow ? "Yes" : "No"}</td>
                                                        <td>{element?.whatsappFollow ? "Yes" : "No"}</td>
                                                    </tr>
                                                </tbody>
                                            )
                                        })}
                                    </table>
                                </div>
                            </div>
                        </div>
                        : ""
                }
                {/* </div>*/}
            </div>
        </React.Fragment>
    )
}

export default Lead;